module.exports = __webpack_public_path__ + "static/img/pasturas_alfalfaencubos.6c79dea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/pasturas_alfalfaencubos.jpg
// module id = SFjt
// module chunks = 0